import React from 'react';
import styles from './highlights.module.scss';
import { useTranslation } from 'next-i18next';
import { combineCN } from '@helpers/styles.helper';
import mainStyles from '../../../pages/investors/investors.module.scss';

const InvestorsHighlightsSection = () => {
	const { t } = useTranslation();

	const highlights = [
		{
			number: t('investor_highlights_stat1_number'),
			label: t('investor_highlights_stat1_label')
		},
		{
			number: t('investor_highlights_stat2_number'),
			label: t('investor_highlights_stat2_label')
		},
		{
			number: t('investor_highlights_stat3_number'),
			label: t('investor_highlights_stat3_label')
		},
		{
			number: t('investor_highlights_stat4_number'),
			label: t('investor_highlights_stat4_label')
		}
	];

	return (
		<section
			className={combineCN(
				'd-flex f-column f-center',
				styles.highlights_wrapper,
				mainStyles.main_section_wrapper
			)}
		>
			<h2 className={mainStyles.title}>{t('investor_relations_key_highlights')}</h2>
			<div className={combineCN('d-flex f-column f-center w-100', styles.content_wrapper)}>
				<div className={combineCN('d-flex f-center', styles.stats_container)}>
					{highlights.map((highlight) => (
						<div
							key={highlight.label}
							className={combineCN('d-flex f-column f-center', styles.stat_item)}
						>
							<div className={styles.stat_number}>{highlight.number}</div>
							<div className={styles.stat_label}>{highlight.label}</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default InvestorsHighlightsSection;
